var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'invalid' : _vm.isInvalid}},[_c('vue-multiselect',{staticClass:"appup-multiselect",attrs:{"id":_vm.id,"multiple":true,"track-by":"value","label":"text","placeholder":_vm.placeholder,"options":_vm.dropdownItems,"searchable":true,"allow-empty":false},model:{value:(_vm.selectedObjects),callback:function ($$v) {_vm.selectedObjects=$$v},expression:"selectedObjects"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/multiselect/multiselect.vue